export default "__VITE_ASSET__CL76bvYt__"